// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BillCreation_wrapper__2gq7e","customer-wrapper":"BillCreation_customer-wrapper__dkA2W","prod-actionmenus-wrapper":"BillCreation_prod-actionmenus-wrapper__WC65V"};